import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const NewTextField = styled(TextField)`
    
    &.fildset: {border: none;}
    padding: 0px !important;
    
`